export const layerAtributes = () => {
    return  [
        {
            id: 4,
            name:'Punto de Calor',
            properties: [
                {'name': 'País','key': 'd1',type:'string'},
                {'name': 'Estado','key': 'd2',type:'string'},
                {'name': 'Municipio','key': 'd3',type:'string'},
                {'name': 'Vegetación', 'key':'d4',type:'string'},
                {'name': 'Anp afectada', 'key': 'd5',type:'string'},
                {'name': 'Pendiente', 'key':'d6',type:'string'},
                {'name': 'Tipo', 'key': 'tipo',type:'string'},
                {'name': 'Satélite', 'key': 'd9',type:'string'},
                {'name': 'Fecha', 'key': 'd10',type:'date'},
                {'name': 'Hora', 'key': 'd10',type:'hours'}
            ]
        },
        {
            id: 22,
            name:'ANP',
            properties: [
                {'name': 'Nombre','key': 'nombre',type:'string'}
            ]
        },
        {
            id: 88,
            name:'Áreas quemadas (AQ)',
            properties: [
                {'name': 'Día','key': 'f1',type:'number'},
                {'name': 'Fecha', 'key': 'f2',type:'string'}
            ]
        },        {
            id: 89,
            name:'Áreas quemadas (AQ)',
            properties: [
                {'name': 'Día','key': 'f1',type:'number'},
                {'name': 'Fecha', 'key': 'f2',type:'string'}
            ]
        },
        {
            id: 32,
            name:'P. Calor filtro',
            properties: [
                {'name': 'País','key': 'f6',type:'string'},
                {'name': 'Estado','key': 'f7',type:'string'},
                {'name': 'Municipio','key': 'f8',type:'string'},
                {'name': 'Vegetación', 'key':'f10',type:'string'},
                {'name': 'Anp afectada', 'key': 'f12',type:'string'},
                {'name': 'Pendiente', 'key':'f13',type:'string'},
                {'name': 'Tipo', 'key': 'f1',type:'string'},
                {'name': 'Satélite', 'key': 'f14',type:'string'},
                {'name': 'Fecha', 'key': 'f4',type:'date'},
                {'name': 'Hora', 'key': 'f4',type:'hours'}
            ]
        },
        {
            id: 33,
            name:'Estadísticas',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 34,
            name:'Municipios',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 40,
            name:'P. Calor Histórico',
            properties: [
                {'name': 'País','key': 'f6',type:'string'},
                {'name': 'Estado','key': 'f7',type:'string'},
                {'name': 'Municipio','key': 'f8',type:'string'},
                {'name': 'Fecha', 'key': 'f4',type:'date'},
                {'name': 'Hora', 'key': 'f4',type:'hours'},
                {'name': 'Tipo', 'key': 'f14',type:'string'}
            ]
        },
        {
            id: 41,
            name:'Modis Histórico',
            properties: [
                //{'name': 'Id','key': 'f0',type:'number'},
                {'name': 'Día','key': 'f1',type:'number'},
                {'name': 'Fecha', 'key': 'f2',type:'string'}
            ]
        },
        {
            id: 50,
            name:'Estados/México',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'},
                {'name': 'Municipio','key': 'nom_mun',type:'string'}
            ]
        },
        {
            id: 52,
            name:'Estados/Estados Unidos',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 53,
            name:'Estados/Guatemala',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 54,
            name:'Estados/Belize',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 55,
            name:'Estados/Honduras',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 56,
            name:'Estados/El Salvador',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 57,
            name:'Estados/Nicaragua',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 58,
            name:'Estados/Costa Rica',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 59,
            name:'Estados/Panamá',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 60,
            name:'Municipios/México',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 62,
            name:'Municipios/Estados Unidos',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 63,
            name:'Municipios/Guatemala',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 64,
            name:'Municipios/Belize',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 65,
            name:'Municipios/Honduras',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 66,
            name:'Municipios/El Salvador',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 67,
            name:'Municipios/Nicaragua',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 68,
            name:'Municipios/Costa Rica',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 69,
            name:'Municipios/Panamá',
            properties: [
                {'name': 'País','key': 'nom_pais',type:'string'},
                {'name': 'Estado','key': 'nom_estado',type:'string'}
            ]
        },
        {
            id: 105,
            name:'P. Calor GOES-LANOT',
            properties: [
                {'name': 'Satélite','key': 'Satelite',type:'string'},
                {'name': 'País','key': 'Pais',type:'string'},
                {'name': 'Estado','key': 'Estado',type:'string'},
                //{'name': 'Land_cover','key': 'Land_Cover',type:'string'},
                {'name': 'Fecha', 'key': 'Fecha',type:'string'},
                {'name': 'Hora(CDMX)', 'key': 'Hora',type:'string'},
                {'name': 'Latitud','key': 'lat',type:'number'},
                {'name': 'Longitud','key': 'lon',type:'number'},
                {'name': 'FRP','key': 'FRP',type:'number'},
                {'name': 'Veg INEGI','key': 'Veg_s7_co',type:'string'},
                {'name': 'Pendiente %','key': 'Pendiente',type:'number'},
                {'name': 'ANP','key': 'ANP',type:'string'},
                {'name': 'PC Estable','key': 'PC_Estable',type:'string'},
                {'name': 'Tipo de PCE','key': 'Tipo_PCE',type:'string'},
                {'name': 'Nombre de PCE','key': 'Nombre_PCE',type:'string'},
            ]
        },
        {
            id: 106,
            name:'P. Calor GOES-LANOT <br/> (Última observación)',
            properties: [
                {'name': 'Satelite','key': 'Satelite',type:'string'},
                {'name': 'País','key': 'Pais',type:'string'},
                {'name': 'Estado','key': 'Estado',type:'string'},
                {'name': 'Fecha', 'key': 'Fecha',type:'string'},
                {'name': 'Hora(CDMX)', 'key': 'Hora',type:'string'},
                {'name': 'Num. Obs', 'key': 'obs',type:'number'},
                {'name': 'Latitud','key': 'lat',type:'number'},
                {'name': 'Longitud','key': 'lon',type:'number'},
                {'name': 'FRP','key': 'FRP',type:'number'},
                {'name': 'Veg INEGI','key': 'Veg_s7_co',type:'string'},
                {'name': 'Pendiente %','key': 'Pendiente',type:'number'},
                {'name': 'ANP','key': 'ANP',type:'string'},
                {'name': 'PC Estable','key': 'PC_Estable',type:'string'},
                {'name': 'Tipo de PCE','key': 'Tipo_PCE',type:'string'},
                {'name': 'Nombre de PCE','key': 'Nombre_PCE',type:'string'},
            ]
        },
        {
            id: 108,
            name:'P. Calor GOES-NOAA',
            properties: [
                {'name': 'Pais','key': 'pais',type:'string'},
                {'name': 'Estado','key': 'estado',type:'string'},
                {'name': 'Municipio','key': 'municipio',type:'string'},
                {'name': 'Fecha', 'key': 'Fecha',type:'string'},
                {'name': 'Hora(CDMX)', 'key': 'Hora',type:'string'},
                //{'name': 'Area', 'key': 'Area',type:'number'},
                {'name': 'FRP (MW)', 'key': 'Power',type:'number'},
                {'name': 'Temp.(K)', 'key': 'Temp',type:'number'},
                {'name': 'DQF', 'key': 'DQF',type:'number'},
                {'name': 'Mask Class', 'key': 'Mask_class',type:'string'}

            ]
        },
        {
            id: 109,
            name:'P. Calor GOES-NOAA <br/> (Última observación)',
            properties: [
                {'name': 'Pais','key': 'pais',type:'string'},
                {'name': 'Estado','key': 'estado',type:'string'},
                {'name': 'Municipio','key': 'municipio',type:'string'},
                {'name': 'Fecha', 'key': 'Fecha',type:'string'},
                {'name': 'Hora(CDMX)', 'key': 'Hora',type:'string'},
                //{'name': 'Area', 'key': 'Area',type:'number'},
                {'name': 'FRP (MW)', 'key': 'Power',type:'number'},
                {'name': 'Temp.(K)', 'key': 'Temp',type:'number'},
                {'name': 'DQF', 'key': 'DQF',type:'number'},
                {'name': 'Mask Class', 'key': 'Mask_class',type:'string'},
                {'name': 'Num. Obs', 'key': 'obs',type:'number'}
            ]
        },
        {
            id: 120,
            name:'Emisiones Gases RAVE (Kg) <br/> (Última observación)',
            properties: [
                {'name': 'Pais','key': 'pais',type:'string'},
                {'name': 'Estado','key': 'estado',type:'string'},
                {'name': 'Municipio','key': 'municipio',type:'string'},
                {'name': 'Fecha', 'key': 'fecha',type:'string'},
                {'name': 'Hora(CDMX)', 'key': 'hora',type:'string'},
                {'name': 'BC', 'key': 'BC',type:'number'},
                {'name': 'CH4', 'key': 'CH4',type:'number'},
                {'name': 'CO', 'key': 'CO',type:'number'},
                {'name': 'CO2', 'key': 'CO2',type:'number'},
                {'name': 'NH3', 'key': 'NH3',type:'number'},
                {'name': 'NOx', 'key': 'NOx',type:'number'},
                {'name': 'OC', 'key': 'OC',type:'number'},
                {'name': 'PM2.5', 'key': 'PM25',type:'number'},
                {'name': 'SO2', 'key': 'SO2',type:'number'},
                {'name': 'VOCs', 'key': 'VOCs',type:'number'},
                {'name': 'QA', 'key': 'QA_class',type:'string'}
            ]
        },
        {
            id: 121,
            name:'Emisiones Gases RAVE (Kg) <br/> (Última observación)',
            properties: [
                {'name': 'Pais','key': 'pais',type:'string'},
                {'name': 'Estado','key': 'estado',type:'string'},
                {'name': 'Municipio','key': 'municipio',type:'string'},
                {'name': 'Fecha', 'key': 'fecha',type:'string'},
                {'name': 'Hora(CDMX)', 'key': 'hora',type:'string'},
                {'name': 'BC', 'key': 'BC',type:'number'},
                {'name': 'CH4', 'key': 'CH4',type:'number'},
                {'name': 'CO', 'key': 'CO',type:'number'},
                {'name': 'CO2', 'key': 'CO2',type:'number'},
                {'name': 'NH3', 'key': 'NH3',type:'number'},
                {'name': 'NOx', 'key': 'NOx',type:'number'},
                {'name': 'OC', 'key': 'OC',type:'number'},
                {'name': 'PM2.5', 'key': 'PM25',type:'number'},
                {'name': 'SO2', 'key': 'SO2',type:'number'},
                {'name': 'VOCs', 'key': 'VOCs',type:'number'},
                {'name': 'Obs', 'key': 'obs',type:'number'}
            ]
        }

    ]
}